import React, { useEffect, useState } from 'react'
import wishlistSelectedIcon from '../../assets/images/png/wishlistSelectedIcon.png'
import likeicon from '../../assets/images/png/like-icon.png'
import Report from '../../assets/images/png/report-icon.svg'
import Share from '../../assets/images/png/share-icon.svg'
import Slider from 'react-slick'
import { Col, Modal, Row, ToastContainer } from 'react-bootstrap'
import ProductsReview from '../ProductDetails/ProductsReview'
import YellowTag from '../../assets/images/png/yellow-tag-icon.svg'
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from 'react-share'
import {
  addProducttoWishlist,
  getWishlistProducts
} from '../../services/WishlistServices'
import { useNavigate, useParams } from 'react-router-dom'
import { reportProduct } from '../../services/ProductsServices'
import {
  addProductToCart,
  getProductsInCart
} from '../../services/CartServices'
import { toast } from 'react-toastify'

const TractorDetails = details => {
  const navigate = useNavigate()
  const [selectedImage, setSelectedImage] = useState(0)
  const [show, setShow] = useState(false)
  const [reportModal, setReportModal] = useState(false)
  const [favouriteItems, setFavouriteItems] = useState([])
  const [comment, setComment] = useState('')
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const { id } = useParams()
  const [description, setDescription] = useState('')
  const tokenitem = localStorage.getItem('token')
  const [productQuantity, setProductQuantity] = useState(1)

  const report = async () => {
    const reportData = {
      productId: id,
      comment: comment
    }
    const res = await reportProduct(reportData, tokenitem)
    setReportModal(false)
  }

  const shareUrl = `https://farmercityv2.testenvapp.com/profile-details/${id}`
  const title = `Product: ${details?.details?.productData?.name}`

  const sharedContent = `${title}\n${shareUrl}`

  const getWishlistItems = async () => {
    const res = await getWishlistProducts(tokenitem)
    setFavouriteItems(res)
  }
  const addToWishlist = async id => {
    if (tokenitem) {
      const productId = id
      await addProducttoWishlist(productId, tokenitem)
      getWishlistItems()
    } else {
      localStorage.setItem('path', '/farmer-shop')
      navigate('/signin')
    }
  }

  useEffect(() => {
    getWishlistItems()
  }, [])

  useEffect(() => {
    if (details?.details?.productData?.description) {
      setDescription(details.details.productData.description)
    }
  }, [details])

  const isInWishlist = id => {
    return (
      favouriteItems && favouriteItems.some(item => item?.productId?._id === id)
    )
  }

  const convertDate = x => {
    const d = new Date(x)
    const options = { month: 'long', day: 'numeric', year: 'numeric' }
    return d.toLocaleDateString('en-US', options)
  }

  const updateQuantity = quantity => {
    if (quantity < 1) {
      quantity = 1
    }
    setProductQuantity(quantity)
  }

  const handleQuantityChange = e => {
    const quantity = parseInt(e.target.value)
    if (!isNaN(quantity)) {
      updateQuantity(quantity)
    }
  }

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    autoplay: false,
    slidesToShow: 4,
    slidesToScroll: 2,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          autoplay: true
        }
      }
    ]
  }

  const product = details?.details?.vendorData?.totalPosts.find(
    product => product._id === id
  )

  return (
    <>
      <ToastContainer />

      <div className='bg_dark_green mb-3 d-md-none d-flex align-items-center justify-content-between p-4 rounded-3'>
        <div>
          <span className='text-white fw-bold ff_arial fs_4xl'>
            ₹{product?.price}
          </span>
          <span className='text-white fw-normal text-capitalize'>
            / {product?.priceType}
          </span>
        </div>
        <img width={25} src={YellowTag} alt='tag' />
      </div>
      <div className='bg-white rounded-3 p-sm-4 py-4 px-3 tractor-details'>
        {details?.details?.productData?.productType === 'machinery' ? (
          <>
            {' '}
            <div className='d-flex align-items-center'>
              <span className='bg-danger text-white ff_heebo fs_3xsm px-2 py-1 rounded-1 text-capitalize'>
                For {details?.details?.productData?.adType}
              </span>
              <span className='ms-3 text-dark-grey ff_heebo fs_3xsm'>
                {details?.details?.productData?.machineType} / Agri Equipments
              </span>
            </div>
            <h4 className='ff_heebo fs_md mt-3 text-dark-grey text-capitalize'>
              {details?.details?.productData?.location}
            </h4>
          </>
        ) : null}

        <h2 className='ff_heebo fs_3xl mt-3 clr_dark_blue fw-bold text-capitalize'>
          {details?.details?.productData?.name}
        </h2>
        <Row>
          <Col className='pe-0' xl={10}>
            <div>
              <img
                className='w-100 mt-2 object-fit-contain rounded-3 mb-4 custom_height_selected_image'
                src={details?.details?.productData?.images?.[selectedImage]}
                alt='Tractor'
              />
            </div>
          </Col>
          <Col className='ps-0' xl={2}>
            <Row>
              <div className='d-flex gap-1 flex-xl-column'>
                {details?.details?.productData?.images?.map((item, index) => (
                  <div key={index} xs={4} className='ps-3 pb-3'>
                    {item ? (
                      <img
                        className='w-100 rounded-3 object-fit-cover cursor-pointer custom_height_select_image'
                        onClick={() => setSelectedImage(index)}
                        src={item}
                        alt='image'
                      />
                    ) : (
                      <img
                        className='w-100 rounded-3 object-fit-cover cursor-pointer custom_height_select_image'
                        onClick={() => setSelectedImage(index)}
                        src={
                          'https://savr-dev-bucket.s3.amazonaws.com/83b1a7b1-728b-4f45-9615-1b7b86b572b4'
                        }
                        alt='image'
                      />
                    )}
                  </div>
                ))}
              </div>
            </Row>
          </Col>
        </Row>
        {/* slider end  */}

        <div className='d-flex gap-2 px-2 justify-content-between align-items-center'>
          <div
            onClick={() => {
              addToWishlist(details?.details?.productData?._id)
            }}
            className='profile_common_btn ff_heebo fw-semibold d-flex align-items-center gap-1 cursor-pointer px-2'
          >
            {isInWishlist(details?.details?.productData?._id) ? (
              <img
                className='postion-relative z-3 p-0 profile_common_btn_img'
                width={18}
                src={wishlistSelectedIcon}
                alt='wishlistIcon'
              />
            ) : (
              <img
                className='postion-relative z-3 p-0 profile_common_btn_img'
                width={18}
                src={likeicon}
                alt='wishlistIcon'
              />
            )}

            <p
              style={{ marginTop: '2px' }}
              className='mb-0 profile_common_btn_fs ff_heebo fw-semibold'
            >
              Bookmark
            </p>
          </div>
          <button
            onClick={() => setReportModal(true)}
            className='profile_common_btn ff_heebo profile_common_btn_fs fw-semibold h-100'
          >
            <img
              className='me-sm-2 me-1 profile_common_btn_img'
              src={Report}
              alt='report'
            />{' '}
            Report
          </button>
          <button
            onClick={handleShow}
            className='profile_common_btn ff_heebo profile_common_btn_fs fw-semibold h-100'
          >
            <img
              className='me-2 profile_common_btn_img'
              src={Share}
              alt='share'
            />{' '}
            Share
          </button>
        </div>
      </div>
      <div className='mt-4'>
        <div className='bg-white p-4 rounded-2'>
          <h4 className='text-uppercase ff_heebo clr_dark_blue fs_md lh-26 fw-bold'>
            Specification
          </h4>
          <div className='light-grey-hr-line w-100 position-relative '>
            <div className='green-hr-line green-hr-line-width'></div>
          </div>
          <div>
            <Row>
              <Col sm={6} md={12} lg={6} className='mt-4'>
                <div className='bg_clr_grey rounded-2 py-2 px-3 '>
                  <div className='py-1 d-flex align-items-center justify-content-between'>
                    <p className='ff_heebo clr_dark_blue fs_xsm fw-medium mb-0'>
                      Price:
                    </p>
                    <p className='ff_heebo clr_dark_grey_2 fs_xsm fw-medium mb-0'>
                      ₹{details?.details?.productData?.price}
                    </p>
                  </div>
                </div>
              </Col>
              <Col sm={6} md={12} lg={6} className='mt-4'>
                <div className='bg_clr_grey rounded-2 py-2 px-3 '>
                  <div className='py-1 d-flex align-items-center justify-content-between'>
                    <p className='ff_heebo clr_dark_blue fs_xsm fw-medium mb-0'>
                      Seller Type:
                    </p>
                    <p className='ff_heebo clr_dark_grey_2 fs_xsm fw-medium mb-0 text-capitalize'>
                      {details?.details?.productData?.sellerType}
                    </p>
                  </div>
                </div>
              </Col>
              <Col sm={6} md={12} lg={6} className='mt-4'>
                <div className='bg_clr_grey rounded-2 py-2 px-3 '>
                  <div className='py-1 d-flex align-items-center justify-content-between'>
                    <p className='ff_heebo clr_dark_blue fs_xsm fw-medium mb-0'>
                      Published:
                    </p>
                    <p className='ff_heebo clr_dark_grey_2 fs_xsm fw-medium mb-0'>
                      {convertDate(details?.details?.productData?.createdAt)}
                    </p>
                  </div>
                </div>
              </Col>
              <Col className='mt-4' sm={6} md={12} lg={6}>
                <div className='bg_clr_grey rounded-2 py-2 px-3 '>
                  <div className='py-1 d-flex align-items-center justify-content-between'>
                    <p className='ff_heebo clr_dark_blue fs_xsm fw-medium mb-0'>
                      Location:
                    </p>
                    <p className='ff_heebo clr_dark_grey_2 fs_xsm fw-medium mb-0'>
                      {details?.details?.productData?.location}
                    </p>
                  </div>
                </div>
              </Col>
              <Col className='mt-4' sm={6} md={12} lg={6}>
                <div className='bg_clr_grey rounded-2 py-2 px-3 '>
                  <div className='py-1 d-flex align-items-center justify-content-between'>
                    <p className='ff_heebo clr_dark_blue fs_xsm fw-medium mb-0'>
                      Category:
                    </p>
                    <p className='ff_heebo clr_dark_grey_2 fs_xsm fw-medium mb-0'>
                      Property
                    </p>
                  </div>
                </div>
              </Col>
              <Col className='mt-4' sm={6} md={12} lg={6}>
                <div className='bg_clr_grey rounded-2 py-2 px-3 '>
                  <div className='py-1 d-flex align-items-center justify-content-between'>
                    <p className='ff_heebo clr_dark_blue fs_xsm fw-medium mb-0'>
                      Condition:
                    </p>
                    <p className='ff_heebo clr_dark_grey_2 fs_xsm fw-medium mb-0'>
                      {details?.details?.productData?.condition}
                    </p>
                  </div>
                </div>
              </Col>
              <Col className='mt-4' sm={6} md={12} lg={6}>
                <div className='bg_clr_grey rounded-2 py-2 px-3 '>
                  <div className='py-1 d-flex align-items-center justify-content-between'>
                    <p className='ff_heebo clr_dark_blue fs_xsm fw-medium mb-0'>
                      Price Type:
                    </p>
                    <p className='ff_heebo clr_dark_grey_2 fs_xsm fw-medium mb-0'>
                      {details?.details?.productData?.priceType}
                    </p>
                  </div>
                </div>
              </Col>
              <Col className='mt-4' sm={6} md={12} lg={6}>
                <div className='bg_clr_grey rounded-2 py-2 px-3 '>
                  <div className='py-1 d-flex align-items-center justify-content-between'>
                    <p className='ff_heebo clr_dark_blue fs_xsm fw-medium mb-0'>
                      Ad Type:
                    </p>
                    <p className='ff_heebo clr_dark_grey_2 fs_xsm fw-medium mb-0 text-capitalize'>
                      {details?.details?.productData?.adType}
                    </p>
                  </div>
                </div>
              </Col>
              <Col className='mt-4' sm={6} md={12} lg={6}>
                <div className='bg_clr_grey rounded-2 py-2 px-3 '>
                  <div className='py-1 d-flex align-items-center justify-content-between'>
                    <p className='ff_heebo clr_dark_blue fs_xsm fw-medium mb-0'>
                      Years Duration
                    </p>
                    <p className='ff_heebo clr_dark_grey_2 fs_xsm fw-medium mb-0 text-capitalize'>
                      {details?.details?.productData?.years}
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div className=' mt-4'>
        <div className='bg-white p-4 rounded-2'>
          <h4 className='text-uppercase ff_heebo clr_dark_blue fs_md lh-26 fw-bold'>
            Description
          </h4>
          <div className='light-grey-hr-line w-100 position-relative'>
            <div className='green-hr-line green-hr-line-width'></div>
          </div>
          <div
            className='ff_heebo fs_xsm clr_dark_grey_2 lh-26 mt-4'
            dangerouslySetInnerHTML={{ __html: description }}
          ></div>
        </div>
      </div>

      {show && (
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Share Machinery</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='row'>
              <div className='col-6'>
                <img
                  className='w-100'
                  src={details?.details?.productData?.images[0]}
                  alt='productsImg'
                />
              </div>
              <div className='col-6'>
                <div>
                  <h2 className='ff_heebo fs_xl clr_dark_blue fw-bold text-capitalize'>
                    {details?.details?.productData?.name}
                  </h2>
                  <div className='py-1 d-flex align-items-center gap-2'>
                    <p className='ff_heebo clr_dark_blue fs_xsm fw-medium mb-0'>
                      Location:
                    </p>
                    <p className='ff_heebo clr_dark_grey_2 fs_xsm fw-medium mb-0'>
                      {details?.details?.productData?.location}
                    </p>
                  </div>
                  <div className='py-1 d-flex align-items-center gap-2'>
                    <p className='ff_heebo clr_dark_blue fs_xsm fw-medium mb-0'>
                      Price:
                    </p>
                    <p className='ff_heebo clr_dark_grey_2 fs_xsm fw-medium mb-0'>
                      ₹{details?.details?.productData?.price}/
                      {details?.details?.productData?.priceType}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className=' justify-content-start'>
            <EmailShareButton url={sharedContent}>
              <EmailIcon size={36} />
            </EmailShareButton>
            <FacebookShareButton url={sharedContent}>
              <FacebookIcon size={36} />
            </FacebookShareButton>
            <WhatsappShareButton url={sharedContent}>
              <WhatsappIcon size={36} />
            </WhatsappShareButton>
            <TelegramShareButton url={sharedContent}>
              <TelegramIcon size={36} />
            </TelegramShareButton>
            <TwitterShareButton url={sharedContent}>
              <TwitterIcon size={36} />
            </TwitterShareButton>
          </Modal.Footer>
        </Modal>
      )}
      {reportModal && (
        <Modal show={reportModal} onHide={() => setReportModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Report</Modal.Title>
          </Modal.Header>
          <Modal.Body className='pb-1'>
            <h3 className='ff_heebo fs_lg'>Report Feedback</h3>
            <div className='light-grey-hr-line w-100 position-relative '>
              <div className='green-hr-line green-hr-line-width'></div>
            </div>
            <textarea
              className='report-text-area w-100 rounded-1 ps-3 py-1 text-grey mt-3'
              placeholder='Please leave your report feedback here'
              value={comment}
              onChange={e => setComment(e.target.value)}
            />
          </Modal.Body>
          <Modal.Footer className=' justify-content-end py-1'>
            <button
              onClick={() => setReportModal(false)}
              className='bg-danger text-white border-0 rounded-2 py-2 px-3 ff_heebo'
            >
              Cancel
            </button>
            <button
              onClick={report}
              className='bg_dark_green text-white border-0 rounded-2 py-2 px-3 ff_heebo'
            >
              Report
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  )
}

export default TractorDetails
